import React, { useEffect, useState } from 'react'
import API from '../methods/API'
// import Table from '../components/core/table/Table'
import TableMUI from '../elements/tables/TableMUI'
import CONSTANTS from '../CONSTANTS'
import ClientView from '../components/widgets/client/ClientView'

const ClientList = () => {
    const [clientList, setClientList] = useState([])
    const [clientToView, setClientToView] = useState(false)


    useEffect(() => {
        getClients()
    }, [])

    const getClients = () => {
        API.getAllClient().then((res) => {
            console.log(res)
            setClientList(res)

        }).catch((err) => {
            console.log(err)
        })
    }


    const remove = (id) => {
        API.removeClient(id).then((res) => {
            console.log(res)
            getClients()

        }).catch((err) => {
            console.log(err)
        })
    }

    return (
        <div className='client-page-main'>
            {/* {clientList.map((client)=><div>{client.created_by && client.created_by.employee_name}: {client.client_name} <strong onClick={()=>remove(client._id)}>Remove</strong></div>)} */}
            <div className='client-list-new'>
                <TableMUI
                    list={[...clientList]}
                    headings={CONSTANTS.CUSTOMER_LIST_TABLE.HEADS}
                    cbView={(cl)=>setClientToView(cl)}
                    remove={remove}
                />
            </div>
            <div className='client-list-new'>
                {clientToView && <ClientView  data={clientToView}/>}
            </div>
        </div>
    )
}

export default ClientList